// How long a grid's first query waits for the user's stored layout (prefs/state) before it loads the defaults
// (GridConfig.firstLoadStateWaitMs). The library's 1.5 s is shorter than prefs/state on a deployed host, above all
// when a page opens several grids at once (the Dashboard sends 9 together, queued behind the browser's 6
// connections): the first query and count went out with the defaults, then the late layout cancelled them and
// sent them again (Dev UI issue 07a, 2026-11-02). Waiting longer costs nothing: the right rows needed the layout anyway.
export const FIRST_LOAD_STATE_WAIT_MS = 5000;
